export type UaAdminSettings = {
  coverageStatus: "research" | "pilot" | "live";
};

export const DEFAULT_UA_ADMIN_SETTINGS: UaAdminSettings = {
  coverageStatus: "research",
};

export function isUaCoverageStatus(value: unknown): value is UaAdminSettings["coverageStatus"] {
  return value === "research" || value === "pilot" || value === "live";
}

/** @deprecated Use UaAdminSettings instead */
export type CoUaAdminSettings = UaAdminSettings;
/** @deprecated Use DEFAULT_UA_ADMIN_SETTINGS instead */
export const DEFAULT_CO_UA_ADMIN_SETTINGS = DEFAULT_UA_ADMIN_SETTINGS;
/** @deprecated Use isUaCoverageStatus instead */
export const isCoUaCoverageStatus = isUaCoverageStatus;
